module.exports = __webpack_public_path__ + "static/img/msg-image-flex-3.29b0ea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vpn/msg-image-flex-3.png
// module id = so5g
// module chunks = 1